import { AxiosError } from "axios";

import { api } from "@/lib/axios";

export interface createAdminBannerParams {
	name: string;
	actived: number;
	title: string;
	sub_title: string;
	button_text: string;
	button_url: string;
	button_color: string;
	image: File | string;
}

export async function createAdminBanner(data: FormData): Promise<
	| {
			status: "success";
	  }
	| { status: "error"; errors: { [key: string]: string } }
> {
	try {
		await api.post("/banner/store", data);

		return {
			status: "success",
		};
	} catch (error: unknown) {
		const axiosError = error as AxiosError<{
			errors: { [key: string]: string };
		}>;

		if (axiosError.response?.status === 422) {
			return {
				status: "error",
				errors: axiosError.response.data.errors,
			};
		}

		return {
			status: "error",
			errors: {
				unknown: "Erro desconhecido. Tente novamente mais tarde.",
			},
		};
	}
}
